import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Container, Row } from 'react-bootstrap';
import "./Privacy_policy.css";
import { Link } from 'react-router-dom';

const Privacy_policy = () => {
    return (
        <section className="privacy-section">
            {/* ---------- Banner ---------- */}

            <div className="privacy-banner">
                <div className="overlay">
                    <h2 className="banner-title">PRIVACY POLICY</h2>
                    <p className="breadcrumb">
                        <Link to={"/"}>Home</Link>
                        <FontAwesomeIcon className='nextfafa' icon={faAngleRight} /> <span>  Privacy Policy </span>
                    </p>
                </div>
            </div>

            {/* ---------- Content ---------- */}
            <Container fluid className="privacy-content-wrapper">
                <Container>
                    <div className='content'>
                        <Row>
                            <Col md={12}>
                                <p className="intro-text">
                                    At <span className="highlight">AI.Origin</span>, we respect your
                                    privacy and are committed to protecting your personal
                                    information. This Privacy Policy explains how we collect, use,
                                    store, and share your data when you access or use our website &
                                    services. By using AI.Origin, you consent to the practices
                                    described in this policy.
                                </p>

                                <hr className="divider" />
                                <div className="policy-text">
                                    <p>
                                        We may collect personal information that you voluntarily
                                        provide, such as your name, email address, and other details
                                        required to register or interact with our services. In
                                        addition, we automatically collect non-personal information
                                        such as your IP address, browser type, operating system, and
                                        usage patterns to help improve our services, optimize your
                                        experience, and analyze website traffic.
                                    </p>

                                    <p>
                                        AI.Origin uses the information we collect to provide and
                                        maintain our services, respond to your inquiries, personalize
                                        your experience, send updates or promotional communications
                                        (if you have opted in), and ensure the security and integrity
                                        of our platform. Your data may also be used to enhance our AI
                                        models, improve functionality, and develop new features.
                                    </p>

                                    <p>
                                        We do not sell, trade, or otherwise transfer your personal
                                        information to third parties for marketing purposes. However,
                                        we may share information with trusted service providers, such
                                        as cloud storage, analytics, or payment processors, to deliver
                                        and improve our services. We may also disclose information
                                        when required by law, to enforce our terms and conditions, or
                                        to protect our rights and the safety of our users.
                                    </p>

                                    <p>
                                        AI.Origin implements industry-standard security measures, including encryption and
                                        secure servers, to protect your information from unauthorized access, alteration,
                                        or disclosure. While we strive to keep your data secure,
                                        no system can guarantee complete security, and you acknowledge that use
                                        of the website is at your own risk.
                                    </p>

                                    <p>
                                        Our website may use cookies and similar tracking technologies to enhance user experience,
                                        track usage patterns,and provide personalized content. You can adjust your browser settings
                                        to manage or disable cookies, though some features of our services may not function correctly
                                        without them.
                                    </p>

                                    <p>
                                        AI.Origin’s services are not intended for individuals under
                                        the age of 18. We do not knowingly collect personal
                                        information from minors,and if we learn that a minor has provided
                                        personal information, we will promptly delete it from our records.
                                    </p>

                                    <p>
                                        We retain your personal data only as long as necessary to provide our services,
                                        comply with legal obligations, resolve disputes, and enforce agreements.
                                        Users have the right to access, update, or request deletion of their personal
                                        information and may opt out of marketing communications at any time by contacting us.
                                    </p>

                                    <p>
                                        We may update this Privacy Policy from time to time to reflect changes in our practices
                                        or legal requirements. Updates will be posted on this page with the revised date, and your
                                        continued use of AI.Origin constitutes acceptance of the updated policy.
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </Container>
        </section>
    )
}

export default Privacy_policy;